import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface CurrencyType {
  id: number;
  name: string;
}

const fetchCurrencyTypes = async (): Promise<CurrencyType[]> => {
  try {
    const { data } = await api.get<CurrencyType[]>('/api/currency-types');
    return data;
  } catch (error) {
    throw new Error('Error al cargar tipos de moneda');
  }
};

export const useCurrencyTypes = () => {
  const { data: currencyTypes = [], isLoading, error } = useQuery({
    queryKey: ['currencyTypes'],
    queryFn: fetchCurrencyTypes,
  });

  return { currencyTypes, isLoading, error };
}; 